// extracted by mini-css-extract-plugin
module.exports = {"heading":"styles_heading__3TquS fonts_fontMain__3VejH","postContainer":"styles_postContainer__21G2s"};